<template>
  <div
    :class="[$style.base, { [$style.selected]: selected }]"
    @click="handleSelect(!selected)"
  >
    <BaseCheckbox
      :modelValue="selected"
      @update:modelValue="handleSelect"
      :label="label"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  label: string;
  selected: boolean;
}>();

const emit = defineEmits(['update:selected']);

const handleSelect = (value: boolean) => {
  emit('update:selected', value);
};
</script>

<style
  lang="scss"
  module
>
.base {
  padding: $spacing;
  border-radius: $radius;
  border: 1px solid var(--border);
  background-color: var(--surface-primary);
  cursor: pointer;
  user-select: none;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;

  @include hover {
    background-color: var(--highlight);
    box-shadow: var(--shadow-hover);
  }

  &:active {
    background-color: var(--highlight-strong);
    box-shadow: none;
    transform: scale(0.97);
    transition-duration: 0s;

    @media (prefers-reduced-motion: reduce) {
      transform: none;
    }
  }

  &.selected {
    border-color: var(--selection);
  }
}
</style>
